'use client';

import { useMemo } from 'react';
import {
  UpdateSignalEditForm,
  type UpdateSignalData,
} from '../forms/UpdateSignalEditForm';
import { updateSignalHitlConfig } from '../../tools/signal/update-signal-hitl-config';

type UpdateSignalEditContentWrapperProps = {
  onClose: () => void;
  onSubmit: (editedArgs: Record<string, unknown>) => void;
  toolName?: string;
  extractedData?: unknown[];
};

export function UpdateSignalEditContentWrapper({
  onClose,
  onSubmit,
  toolName: _toolName,
  extractedData = [],
}: UpdateSignalEditContentWrapperProps) {
  const hitlConfig = updateSignalHitlConfig;

  const initialData = useMemo(
    () => (extractedData[0] ?? {}) as UpdateSignalData,
    [extractedData],
  );

  const handleSubmit = (editedData: UpdateSignalData) => {
    if (!hitlConfig) return;
    const wrappedData = hitlConfig.wrapEditedData([editedData]);
    onSubmit(wrappedData);
  };

  if (!initialData.signalId) return null;

  return (
    <UpdateSignalEditForm
      onClose={onClose}
      onSubmit={handleSubmit}
      initialData={initialData}
    />
  );
}
